import React from 'react'
import { Box, styled } from '@creditas-ui/react'
import { bool, func, oneOf, string } from 'prop-types'

const propTypes = {
  type: oneOf(['text']),
  autoFocus: bool,
  autoComplete: oneOf(['off']),
  component: string,
  disabled: bool,
  id: string,
  name: string,
  value: string,
  placeholder: string,
  className: string,
  onChange: func,
  onFocus: func,
  onBlur: func,
}

const InputElement = styled(Box.withComponent('input'))`
  border: none;
  background: none;
  outline: none;
  padding: 0;
  margin: 0;
  min-height: 16px;
`

const Input = React.forwardRef(
  (
    {
      type = 'text',
      autoFocus = false,
      autoComplete = 'off',
      component = 'input',
      disabled = false,
      name,
      id,
      value,
      placeholder,
      className,
      onChange,
      onFocus,
      onBlur,
      ...props
    },
    ref,
  ) => (
    <InputElement
      {...props}
      ref={ref}
      type={type}
      as={component}
      autoFocus={autoFocus}
      autoComplete={autoComplete}
      disabled={disabled}
      name={name}
      id={id}
      value={value}
      placeholder={placeholder}
      className={className}
      onFocus={onFocus}
      onChange={onChange}
      onBlur={onBlur}
    />
  ),
)

Input.propTypes = propTypes
Input.displayName = 'Input'

export { Input }
